// set-env.js
let environment;

switch (process.env.REACT_APP_ENV) {
    case 'prod':
        environment = require('./environments/env.prod').default;
        break;
    case 'staging':
        environment = require('./environments/env.staging').default;
        break;
    default:
        environment = require('./environments/env.dev').default;
}

export default environment;
